var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"projects"},[_c('h1',{staticClass:"border-bottom mb-4"},[_vm._v(" Projects ")]),_vm._v(" Coming soon ")])}]

export { render, staticRenderFns }